import { Action } from 'redux';
import { ICancelBackgroundJobParams } from '../../../ts/ServerApi/requests/CancelBackgroundJobRequest';
import { CancelBackgroundJob } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface CancelBackgroundJobAction extends Action {
  params: ICancelBackgroundJobParams;
}

export function cancelBackgroundJobAction(params: ICancelBackgroundJobParams) {
  return {
    type: CancelBackgroundJob,
    params,
  };
}

export const isCancelBackgroundJobAction = isActionFactory<CancelBackgroundJobAction>(CancelBackgroundJob);
